import {Order, orderDecoder} from './Order'
import {BpsUser, bpsUserDecoder} from './BpsUser'
import {Customer, customerDecoder} from './Customer'
import {Company, companyDecoder} from './Company'
import {array, Decoder, field, object} from 'json-bouncer'
import {Position, positionDecoder} from './Position'

export interface OrderWithOwnersAndPositions {
    order: Order
    bpsUser: BpsUser
    customer: Customer
    company: Company
    positions: Position[]
}

export function orderWithOwnersAndPositionsDecoder(): Decoder<OrderWithOwnersAndPositions> {
    return object({
        order: field('order', orderDecoder()),
        bpsUser: field('bpsUser', bpsUserDecoder()),
        customer: field('customer', customerDecoder()),
        company: field('company', companyDecoder()),
        positions: field('positions', array(positionDecoder())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderWithOwnersAndPositions.ts